import React from "react";
import convertUTC from "../utils/convertUTC";
import convertUSD from "../utils/convertUSD";
import styled from "styled-components/macro";
import {
  Dialog,
  IconButton,
  InputAdornment,
  TextField,
  Typography as MuiTypography,
} from "@mui/material";
import { display } from "@mui/system";
import { COUNTRIES } from "../constants";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { DateRangePicker } from "mui-daterange-picker";

const Typography = styled(MuiTypography)(display);

export const SimpleSelectCell = ({ cell }) =>
  cell?.column?.columnDef?.selectOptionsLookup?.[cell.getValue()];

export const DateCell = ({ cell }) => convertUTC(cell.getValue());

export const CashCell = ({ cell }) => convertUSD(cell.getValue());

export const MatchEndDateCell = ({ cell }) =>
  cell.getValue() ? convertUTC(cell.getValue()) : "Not Finished";

export const CashChipsCell = ({ cell, row }) =>
  row.original.isCash
    ? convertUSD(cell.getValue())
    : `${cell.getValue()} Chips`;

const CURRENCY_TYPES = {
  0: (value) => `${convertUSD(value)} Bonus Cash`,
  1: (value) => `${value} Chips`,
  2: (value) => `${convertUSD(value)} Real Cash`,
};
export const BalanceCell = ({ cell, row }) =>
  CURRENCY_TYPES?.[row.original.currencyType]?.(cell.getValue());

export const CountryCell = ({ cell }) => COUNTRIES[cell.getValue()];

export const IsWinnerCell = ({ cell }) =>
  cell.getValue() ? (
    <CheckCircleOutlinedIcon color="success" />
  ) : (
    <CancelOutlinedIcon color="error" />
  );

export const AccountMovementCell = ({ cell }) => (
  <Typography
    sx={{ color: cell.getValue() > 0 ? "success.main" : "error.main" }}
  >
    {cell.getValue() > 0 ? "+" : "-"}
    {Math.abs(cell.getValue())}
  </Typography>
);

export const DateRangeFilter = ({ column }) => {
  const [open, setOpen] = React.useState(false);
  const [dateRange, setDateRange] = React.useState({});

  const value =
    dateRange.startDate && dateRange.endDate
      ? `${dateRange.startDate} - ${dateRange.endDate}`
      : "";
  return (
    <>
      <TextField
        variant="standard"
        placeholder={`Filter by ${column.columnDef.header}`}
        onClick={() => setOpen(true)}
        value={value}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear filter"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  setDateRange({});
                  column.setFilterValue([undefined, undefined]);
                }}
                edge="end"
                size="small"
                disabled={!value}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Dialog open={open} maxWidth={false}>
        <DateRangePicker
          open={open}
          toggle={() => setOpen(!open)}
          onChange={(newDateRange) => {
            setDateRange(newDateRange);
            column.setFilterValue([
              Date.parse(newDateRange.startDate),
              Date.parse(newDateRange.endDate),
            ]);
          }}
        />
      </Dialog>
    </>
  );
};
